import { DenormalizedCustomizableGroup, DenormalizedCustomizableQuestion, EntityType, GroupType } from '@packages/types'
import React from 'react'

import type { BottomDrawerValues } from 'themes/common/components/bottomDrawer/useBottomDrawer'

import SummaryDrawerBulkOrder from './SummaryDrawerBulkOrder'
import SummaryDrawerQuestion from './SummaryDrawerQuestion'

import './SummaryDrawerStep.scss'

export type SummaryDrawerStepProps = {
  drawer: BottomDrawerValues
  step: DenormalizedCustomizableGroup | DenormalizedCustomizableQuestion
}

const SummaryDrawerStep = ({ step, drawer }: SummaryDrawerStepProps) => {
  const isBulkOrder = step.entityType === EntityType.Group && step.type === GroupType.BulkOrder

  if (isBulkOrder) {
    return <SummaryDrawerBulkOrder bulkOrder={step} drawer={drawer} />
  }

  if (step.entityType === EntityType.Question) {
    return <SummaryDrawerQuestion question={step} drawer={drawer} />
  }

  return null
}

export default SummaryDrawerStep
